import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { PATHS } from '@shared/constants/paths';
import { ProductService } from '@shared/services/product/product.service';
import { filter, take } from 'rxjs/operators';
import { InventoryProductsToLoad } from '../models/inventory-products-to-load.model';
import { InventoryService } from './inventory.service';

@Injectable({
  providedIn: 'root',
})
export class InventoryResolverService {
  constructor(
    private inventoryService: InventoryService,
    private productService: ProductService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): any {
    const inventoryId = route.params['inventoryId'];

    if (inventoryId === undefined) {
      this.router.navigate([PATHS.INVENTORY]);
      return;
    }

    this.inventoryService.traceInventoryDisplayStart(inventoryId);

    this.inventoryService
      .inventoryProductsToLoad$(inventoryId)
      .pipe(
        filter(
          (inventoryProductsToLoad: InventoryProductsToLoad) =>
            inventoryProductsToLoad.inventoryStateIsLoaded,
        ),
        take(1),
      )
      .subscribe((inventoryProductsToLoad: InventoryProductsToLoad) => {
        if (!inventoryProductsToLoad.inventory) {
          this.inventoryService.inventoryCouldNotBeFound(inventoryId);
          this.router.navigate([PATHS.INVENTORY]);
        } else {
          this.productService.loadProducts(
            inventoryProductsToLoad.productNumbers,
          );
        }
      });
  }
}
